module.exports = __webpack_public_path__ + "static/media/youtube.1605706b.png";